<template>
  <div class="container-fluid">
    <div class="heightcontainer">
      <landing-navbar></landing-navbar>
        <section class="section1 mt-2 pb-2 backgroundcolor12">
            <div class="container row pb-5 pt-5 no-gutters mx-auto ">
                <div class="col-12 pt-lg-5 mt-5 mt-md-1">
                    <div class="col-lg-12 mt-5 mt-lg-1 text-center section1content">
                        <div class="vertical-center mt-5 mt-lg-1 top-padding pl-md-3 pr-md-3">  
                            <span class="fontsize18 bold proximanova-bold pointer" @click="openForm">APPLY NOW</span> 
                            <h2 class="font48-bold-main proximanova-bold mt-3">Influencer Accelerator Programme</h2>    
                            <img src="../../assets/influencer.png" alt="influenecer" class="mx-auto col-12 col-lg-9 pl-0 pr-0">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section2 d-flex mx-auto justify-content-between">
            <div class="container row pb-5 pt-5 no-gutters mx-auto ">
                <div class="border p-4 mb-5 p-md-5">
                    <div class="d-flex flex-column">
                        <span v-for="(line, index1) in section2content1" :key="'cont1'+index1" class="proximanova fontsize20 mb-3" :class="line.color">{{line.li}}</span>
                        <span v-for="(line, index2) in section2content2" :key="'cont2'+index2" class="proximanova fontsize20 mb-3">
                            <span class="proximanova-bold fontsize20 mb-3">{{line.ul}}</span>
                            <li v-for="(list, index3) in line.li" :key="'cont2sub'+index3" class="mb-2 mt-2">{{list}}</li>
                        </span>
                        <span v-for="(line, index4) in section2content3" :key="'cont3'+index4" class="proximanova fontsize20 mb-3">{{line}}</span>
                    </div>
                </div>
                <div class="card border-0 shadow mt-5 mb-5 p-5">
                    <div class="d-lg-flex">
                        <div class="d-flex flex-column col-lg-6">
                            <span class="proximanova-bold fontsize32 black">Influencer programme</span>
                            <span class="proximanova fontsize16 black60 mt-3">You can Apply for the Influencer Program starting today and everyone is welcome. The deadline toapply is Aug 20th, 2022.</span>
                        </div>
                        <div class="d-flex flex-column col-lg-6">
                            <button class="btn fontsize18 signupbtnstyles p-2 mt-3 pl-5 pr-5 borderradius20 mx-auto my-auto newbtnstyles backgroundcolor3 proximanova-semibold white" @click="openForm">Apply</button>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
    </div>    
    <Footer class="footer" ></Footer>
  </div> 
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";
import Footer from '../LandingFooter.vue'
import router from '../../router.js'
import LandingNavbar from './Navbar.vue'
import wndata from '../../js/wn_data.json'
import $ from 'jquery'
export default {
  components: {
    BottomFooter,   
    Footer,
    LandingNavbar
  },
  data() {
    return {
        section2content1 : [
            {li : "Creativity is inventing, experimenting, growing, taking risks, breaking rules, making mistakes and having fun as rightly said by Mary Lou Cook.", color : "black"},
            {li : "With this approach we at Worknotion look at Content Creators as the torchbearer of future.", color : "black"},
            {li : "Currently it is noticeable that social media algorithms in popular platforms eg: Youtube no longer give value and visibility to content filled with knowledge rather depends on videos that go viral making it difficult for new content creators to grow and expand their business through creative forms. This is a disappointing phenomenon for new and upcoming content creators who have valuable knowledge to offer but not getting platforms to build steady careers with sustainable income. Saas platforms have inflated investment rates, earnings dependency on #tips #sponsorships and #ads as regular income doesn’t function in this volatile online world. ", color : "black"},
            {li : "That is why we @worknotion evaluated all social media platforms and bought an effective solution to problems you are facing and built the next step for you to become a successful Influencer.", color : "black"},
            {li : "“Creator Accelerator” program:", color : "blue"},
            {li : "Worknotion is overjoyed to announce the launch of our most awaited venture today: Creator Accelerator Program. It is our first initiative in the world of working Prefessionals specifically curated for Influencers or Content Creators.", color : "black"},
            {li : "The motto of this programme is to help aspiring or new content creators gain all useful resources needed for implementation of their ideas and creativity into powerful content converting into a successful business following the road of financial independence.", color : "black"},
            {li : "Opportunities for “Content Creators”:", color : "blue"}
        ],
        section2content2 : [
            {
                ul : "Create “bomblastic” videos: ",
                li : [
                    // "All necessary equipment and resources needed to create content like Microphone, Webcam etc. will be provided to you exclusively by Worknotion.",
                    "You will get to be a part of worknotion team through conceptualizing ideas, take part in editing content as well as creative development department",
                    "Recommending target audience suitable towards your Content kind driving traffic"
                ]
            },
            {
                ul : "Promote 10x visibility to your Worknotion profile:",
                li : [
                    "We will help you access in-built design services for your creations.",
                    "Helping to promote your content inside as well as outside Worknotion",
                    "Provide resources and support in establishing your brand, audience as well as community"
                ]
            },
            {
                ul : "Paying you for your creation:",
                li : [
                    "Assured monthly remuneration as added bonuses",
                    "Suggest more business collaborations with you so that your creation generates more revenue in the long run.",
                ]
            },
        ],
        section2content3 : [
            "All you have to do is trust us on this exciting endeavour of content creation and put your whole passion in creating content that shows how different you are from the rest of the creators.",
            "In store for you is some amazing WORKNOTION CREATOR SWAG, start now to not lose anymore opportunities.",
            "Book yourself for the Creator Accelerator program starting today and theplatform is open to applications from everyone regardless of place, ethnicity,gender, background.",
            "Marginalized communities are welcome to apply. Deadline for applications: 30th August, 2022",
            "The program is expected to begin from August-September2022 session.",
            "Eligibility criteria for getting selected as an influencer at worknotion: ",
            "You must be a registered member of worknotion having posted atleast 5 videos on the platform before to consider your application to the creator program as valid. ",
            "If you are interested, please submit your application in online mode as soon as possible.",
            "Deadline for valid applications is 20th August, 2022, but we may accept applications until the batch starts in August depending on our requirements. We choose to review late applications but if you apply late chances are your application will be put on hold till the batch starts in August. ",
            "We are accepting applications of creators who want to have conversations with us on a Rolling basis.",
            "You will get a confirmation mail by 2nd September having submitted your application by stipulated deadline",
            "During the two month creator program we will invite speakers every 2 weeks to have a TALKSHOW regarding their journey towards becoming a content creator, their achievements and the learnings they acquired on this path.",
            "In one or two weeks, you will be engaging in group meetings where you will discuss your ideas with other content creators for an hour.",
            "These group meetings will serve as an opportunity for you to get to know other content creators involved in this program, share experiences with each other, offer help and build a community.",
            "The Creator program doesn’t vanish after two months, only your prior engagements will go away. Worknotion will continue to help you create incredible content, helping you monetize your knowledge and achieve further goals towards financial independence. Your ideas will always be welcome and we will continue to aid you towards your dream journey!"
        ]
    };
  },
  methods: {
    openForm : function() {
      var x = document.createElement('a')
      x.target = '_blank'
      x.href = wndata.contentcreatorsGoogleform;
      x.click()
    }
  },
  mounted: function() {
    window.scrollTo(0, 0)
  },
  computed: {
    
  }
};
</script>
<style scoped>
.font48-bold-main{
    font-size: 40px !important;
}
.border {
    border: 3px solid #DBDBDB !important;
    border-radius: 5px;
    width: 100%;
}
.card{
    width: 100%;
    border-radius: 5px;
}
.signupbtnstyles{
  width: 200px;
  height: 50px;
  font-size: 20px;
  border-radius: 40px !important;
}
@media (min-width: 992px){
 
}
section {
 margin: 0 0 0rem 0rem  !important ;
}
.footer {
  background-color: black;       
  color : white;
  position: sticky;
}
.top-padding{
  padding-top:3rem !important;
}
h2{
  font-weight: 300;
}
.section1 {
  background-color:white;
}
.section2 {
  background-color:white;
}   
@media screen and (min-width: 300px) and (max-width: 350px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 20px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 20px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .section1content{
    margin-top: 12% !important;
  }
  .top-padding{
    padding-top:0rem !important;
  }
  .signupbtnstyles{
    border-radius: 40px !important;
    margin-top: 40px !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .section1content{
    margin-top: 12% !important;
  }
  .signupbtnstyles{
    border-radius: 40px !important;
    margin-top: 40px !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 24px;
  }
  .font24-reg-main {
    font-size: 18px;
  }
}
@media screen and (max-width: 900px) and (min-width: 800px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 700px) and (min-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 800px) and (min-width: 700px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (min-width: 600px){  
  
}
</style>
